import {
  FormControlConfig,
  IFormControlConfig,
} from '../eo-base-form-control/eo-base-form-control.model';

export interface IEoRadioButtonConfig extends IFormControlConfig {
  type?: 'radioButton';
  radioButtonStyleClass?: string;
  value?: any;
}

export class EoRadioButtonConfig
  extends FormControlConfig
  implements IEoRadioButtonConfig
{
  override type?: 'radioButton';
  radioButtonStyleClass?: string;
  value?: any;

  constructor();
  constructor(obj: IEoRadioButtonConfig);
  constructor(obj?: IEoRadioButtonConfig) {
    super(obj as IFormControlConfig);
    this.type = 'radioButton';
    if (obj?.value) this.value = obj.value;
    this.radioButtonStyleClass = obj?.radioButtonStyleClass ?? '';
  }
}
